import Vue from 'vue'
import App from './App'
import VueMaterial from 'vue-material'
import VueI18n from 'vue-i18n'
import 'vue-material/dist/vue-material.css'
import './css/flexboxgrid.css'
import './css/global.css'

Vue.use(VueI18n)
Vue.use(VueMaterial)

Vue.material.registerTheme({
  app: {
    primary: 'orange',
    accent: 'deep-purple'
  }
})

// Setup localization
//let storedLang = VueCookie.get('lang');
//Vue.config.lang = (storedLang ? storedLang : navigator.language.split("-",1)[0] || 'en');
//Vue.config.fallbackLang = 'en'

const messages = {
  en: require('./strings/en.js').default,
  hu: require('./strings/hu.js').default
}

const i18n = new VueI18n({
  locale: 'en',
  messages,
})


new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js